import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Btn } from "@/components/shared";
import { UserCircle, Inbox, Gavel, DollarSign, FileSignature, ChevronLeft, ChevronRight, Check } from "lucide-react";

const STEPS = [
  { icon: UserCircle, title: "1 · Complete your onboarding", body: "Finish your profile, add your service ZIP codes and counties, upload your documents, and switch Available on so dispatch can send you nearby work." },
  { icon: Inbox, title: "2 · Receive work", body: "When a job near you is posted you'll get a notification. Open 'My Work' to see nearby jobs and review the scope, address and due date." },
  { icon: Gavel, title: "3 · Place your bid", body: "On a job you can see the allowable amount. Enter your payout/bid and submit — dispatch reviews and assigns, and you're notified when you win it." },
  { icon: DollarSign, title: "4 · Check pricing", body: "Open 'My Pay Rates' and the Price Book to see your blended pay per service and the standard 45-day payment terms before you accept a job." },
  { icon: FileSignature, title: "5 · Sign your contractor agreement", body: "A reminder sits on your Profile until it's signed. Review and accept the contractor agreement there to stay eligible for work." },
];

export function AppWalkthrough({ open, onClose }) {
  const [i, setI] = useState(0);
  const S = STEPS[i];
  const Icon = S.icon;
  const last = i === STEPS.length - 1;
  const close = () => { setI(0); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="bg-[#141417] border-2 border-[#FF5722] text-white rounded-none max-w-lg" data-testid="app-walkthrough">
        <div className="space-y-5 py-2">
          <div className="w-14 h-14 bg-[#FF5722] text-black border-2 border-black shadow-[3px_3px_0px_#000] flex items-center justify-center animate-rise"><Icon size={26} /></div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">How to use the app</div>
            <h2 className="font-head font-black uppercase text-2xl text-white tracking-tight mt-1" data-testid="walkthrough-title">{S.title}</h2>
            <p className="text-zinc-300 mt-2 leading-relaxed">{S.body}</p>
          </div>
          <div className="flex gap-1.5">{STEPS.map((_, n) => <div key={n} className={`h-1.5 flex-1 transition-colors ${n <= i ? "bg-[#FF5722]" : "bg-zinc-800"}`} />)}</div>
          <div className="flex justify-between gap-2">
            <Btn variant="secondary" disabled={i === 0} onClick={() => setI(i - 1)} data-testid="walkthrough-back"><ChevronLeft size={16} /> Back</Btn>
            {last
              ? <Btn onClick={close} data-testid="walkthrough-done"><Check size={16} /> Got it</Btn>
              : <Btn onClick={() => setI(i + 1)} data-testid="walkthrough-next">Next <ChevronRight size={16} /></Btn>}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
